export enum SortingMode {
  Asc = "ASC",
  Desc = "DESC"
}